import React from 'react';
import { Link } from 'gatsby';
import { css } from 'glamor';

export default ({ href, children, headerLink, isExternal, ...rest }) => {
    const linkStyleClass = css({
        color: headerLink ? '#3d3f41' : '#0099CC',
        transition: '.3s all ease',
        textDecoration: 'none',
        ':hover': {
            color: headerLink ? '#0099CC' : '#8d8d8f',
        },
    });

    return (
        isExternal ?
            <a href={href} className={linkStyleClass} {...rest}>{children}</a> :
            <Link to={href} className={linkStyleClass}>{children}</Link>
    );
};
